import { createPortal } from 'react-dom'
import { IconX } from '@tabler/icons-react'
import { getFileDisplayName } from '../utils/helpers'

const ImagePreviewModal = ({ image, onClose }: any) => {
  if (!image?.content) return null // Render nothing if no image is available

  const modalContent = (
    <div className="fixed inset-0 bg-black/70 flex justify-center items-center z-[99999] flex-col">
      <div className="fixed top-0 w-full p-1 flex justify-between items-center bg-[#262626]">
        <div className="text-white m-0">{getFileDisplayName(image?.name)}</div>
        <IconX
          data-testid="close-btn"
          size={28}
          className="text-white hover:text-[var(--text-disabled)] cursor-pointer transition-colors duration-300"
          onClick={onClose}
        />
      </div>
      <div className="rounded-lg overflow-hidden max-w-[90%] max-h-full flex flex-col mt-5">
        <div className="flex-1 overflow-auto flex justify-center items-center p-2.5">
          <img src={image?.content} alt="Preview" className="max-w-full max-h-full" />
        </div>
      </div>
    </div>
  )

  return createPortal(modalContent, document.body)
}

export default ImagePreviewModal
